import NumberFormatHelper from '@/ui-kit/helpers/NumberFormatHelper';
import ChartDataBuilder from '../builder/chart-data-builder';

export default class SoldPriceChart {
  constructor(chartData, width) {
    return new ChartDataBuilder()
      .setChartConfig((builder) => builder.setWidth(width).setId('Sales Trend'))
      .setColorsConfig((builder) => builder.setColors(['#009fd4', '#0055d4']))
      .setStrokeConfig((builder) => builder.setWidth([0, 2, 2]))
      .setXAxisConfig((builder) => builder.setCategories(chartData.timeline))
      .setYAxisConfig(
        (builder) => builder
          .addYAxisItem((axisBuilder) => axisBuilder
            .setTitle('Sale Price Average')
            .setLabelFormatter((value) => value && NumberFormatHelper.formatCurrency(value)))
          .addYAxisItem((axisBuilder) => axisBuilder
            .setColor('#0055d4')
            .setTitle('Sold Price / List Price Ratio')
            .setForceNiceScale(true)
            .setOpposite(true)
            .setMax(110)
            .setMin(80)
            .setLabelFormatter((value) => value && `${value}%`)),
      )
      .build();
  }
}
